import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import {
  hoursAfterAcceptanceKeys,
  formatSimpleCancellationDate
} from '@common/utils/cancellationPolicies';

import { getBestOffer } from '@sru/utils/offers';

import { HOMECARD_IMAGE_SIZES } from '../constants';

export const getHomecardImageSet = photoUrls =>
  Object.keys(photoUrls)
    .filter(size => photoUrls[size] && HOMECARD_IMAGE_SIZES[size])
    .map(size => `${photoUrls[size]} ${HOMECARD_IMAGE_SIZES[size]}`)
    .join(', ');

export const getUrlWithMovingDates = (url, moveIn, moveOut) => {
  let getParams = [];
  getParams = moveIn ? [...getParams, `move-in=${moveIn}`] : getParams;
  getParams = moveOut ? [...getParams, `move-out=${moveOut}`] : getParams;

  return getParams.length ? `${url}?${getParams.join('&')}` : url;
};

const areBillsIncluded = features => {
  // Required Bills to show label
  const requiredBills = {
    5000: 'electricity',
    5001: 'water',
    5002: 'gas',
    5003: 'wifi'
  };

  return Object.keys(requiredBills).every(billId => features[billId]);
};

export const getLabels = (
  noDeposit,
  cancellationDeadline,
  features = {},
  showBillsIncludedLabel,
  offers,
  currencyIsoCode,
  showLandlordPropertyOffers
) => {
  const labels = [];

  if (noDeposit) {
    const noDepositLabel = {
      text: `${trans('homecard.label.no_deposit')}`,
      color: 'blue-indigo',
      tooltip: `${trans('tooltip.message.no-deposit')}`
    };
    labels.push(noDepositLabel);
  }

  if (showBillsIncludedLabel && areBillsIncluded(features)) {
    const includedBillsLabel = {
      text: trans('homecard.label.bills_included'),
      color: 'blue-cerulean',
      tooltip: trans('tooltip.message.bills_included')
    };
    labels.push(includedBillsLabel);
  }

  if (cancellationDeadline && cancellationDeadline.freeCancellationCurrently) {
    const hasHoursAfterAcceptance =
      cancellationDeadline.freeCancellationDeadlineType ===
      'hoursAfterAcceptance';

    const renderHoursAfterAcceptanceMessage = `${trans(
      `${hoursAfterAcceptanceKeys.title}`
    )} ${trans(`${hoursAfterAcceptanceKeys.afterBookingAccepted}`, {
      hour: cancellationDeadline.freeCancellationDeadlineValue
    })}`;

    const freeCancellationLabel = {
      text: `${trans('homecard.label.free_cancellation')}`,
      color: 'blue-cerulean',
      tooltip: hasHoursAfterAcceptance
        ? renderHoursAfterAcceptanceMessage
        : `${trans(
            'cancellationPolicy.free.message',
            formatSimpleCancellationDate(
              cancellationDeadline.freeCancellationDeadlineValue
            )
          )}`
    };
    labels.push(freeCancellationLabel);
  }

  if (showLandlordPropertyOffers) {
    const bestOffer = getBestOffer(offers);
    if (bestOffer) {
      let discount = `${bestOffer.discountValue} %`;
      if (bestOffer.discountType === 'fixed') {
        discount = formatPrice(bestOffer.discountValue, currencyIsoCode);
      }

      labels.push({
        text: trans('homecard.label.up_to_discount', { discount }),
        color: 'red-cinnabar'
      });
    }
  }

  return labels;
};

export const getRatingFromReviews = (reviews = {}) => reviews.ratingAverage;
